const getters = {
  usersArray: ({ users }) => Object.keys(users).map(key => users[key]),
  newUser: ({ newUser }) => newUser,
  currentPage: ({ currentPage }) => currentPage,
  totalPageCount: ({ totalPageCount }) => totalPageCount,
  perPage: ({ perPage }) => perPage,
  selectedRoles: ({ selectedRoles }) => selectedRoles,
  selectedSites: ({ selectedSites }) => selectedSites
}

export default getters
